import memoize from 'lodash/fp/memoize'

const scrollbarElementProperties = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px',
  overflow: 'scroll'
}

export type ScrollDirection = 'vertical' | 'horizontal'

export const getScrollbarSize = memoize((direction: ScrollDirection = 'vertical') => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0
  }

  const scrollElement = document.createElement('div')

  Object.keys(scrollbarElementProperties).forEach(property => {
    scrollElement.style[property as any] = scrollbarElementProperties[property as keyof typeof scrollbarElementProperties]
  })

  document.body.appendChild(scrollElement)

  let size = 0

  if (direction === 'vertical') {
    size = scrollElement.offsetWidth - scrollElement.clientWidth
  }

  if (direction === 'horizontal') {
    size = scrollElement.offsetHeight - scrollElement.clientHeight
  }

  document.body.removeChild(scrollElement)

  return size
})
